import React from 'react';
import PropTypes from 'prop-types';

function QuestionIntro(props) {

  const bgCategoryImage = { backgroundImage: `url(./images/category-image-${props.questionType.toLowerCase()}.png)`}

  return (
    <div>
        <div className={"question-category " + props.questionType.toLowerCase()} style={bgCategoryImage} />
        <h2 className="question">
            {props.questionIntro}
        </h2>
    </div>
  );
}

QuestionIntro.propTypes = {
  questionIntro: PropTypes.string.isRequired
};

export default QuestionIntro;



/** WEBPACK FOOTER **
 ** ./src/components/QuestionIntro.js
 **/